import React from 'react';
import useNotification from 'hooks/useNotification';
import { ResponseError } from 'types/responses';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, useState } from 'react';
import { HttpStatusCode } from 'axios';

function QueryProvider({ children }: PropsWithChildren) {
	const { showNotification } = useNotification();

	const [queryClient] = useState(
		() =>
			new QueryClient({
				queryCache: new QueryCache({
					onError: (error) => {
						if ((error as unknown as ResponseError)?.code === HttpStatusCode.InternalServerError) {
							showNotification(error.message, { variant: 'error' });
						}
					},
				}),
				mutationCache: new MutationCache({
					onError: (error) => {
						if ((error as unknown as ResponseError)?.code === HttpStatusCode.InternalServerError) {
							showNotification(error.message, { variant: 'error' });
						}
					},
				}),
				defaultOptions: {
					queries: {
						refetchOnWindowFocus: false,
						retry: false,
						staleTime: 5 * 60 * 1000,
					},
				},
			})
	);

	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

export default QueryProvider;
